<template>
  <mdb-container class="gp-has-header">
    <h5> <mdb-spinner/>Logging You Out</h5>
  </mdb-container>
</template>

<script>

import {mdbContainer, mdbSpinner} from 'mdbvue';

export default {
  name: 'logging-out',
  components: {
    mdbSpinner, mdbContainer
  },
  mounted() {
    this.$store.dispatch("logout")
  }
}
</script>
